import { Bundle } from '@ali/visualengine';
import React from 'react';
import Icon from './logo.tsx';
import { ButtonPosition } from '@/common/manager/position/button-position';
import {
  getDataSetterSnippet,
  getObjectSetterSnippet,
} from '@/common/manager/setter-snippet';
import { getJSExpressionPrototype } from '@/common/manager/common-style';

const CnSliderBundle = Bundle.createPrototype({
  title: '轮播图（CnSlider）',
  componentName: 'CnSlider',
  category: '反馈',
  icon: Icon,
  docUrl:
    'https://cone.cainiao-inc.com/market/awesome?business=internationality&id=3313',
  isContainer: false,
  canHovering: true,
  canSelecting: true,
  canDragging: true,
  enableCopy: true,
  snippets: [
    {
      screenshot:
        'https://img.alicdn.com/imgextra/i4/O1CN01yPab9A23vhGcFPJWy_!!6000000007318-0-tps-1434-678.jpg',
      label: 'CnSlider',
      schema: {
        componentName: 'CnSlider',
        props: {},
      },
    },
  ],
  configure: [
    {
      name: 'isCnSlider',
      title: 'isCnSlider',
      initialValue: true,
      display: 'none',
    },
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
    ...getDataSetterSnippet(),
    {
      title: '样式',
      name: 'normalStyle',
      display: 'accordion',
      collapsed: false,
      setter: getObjectSetterSnippet({
        items: [
          {
            name: 'height',
            title: '轮播图高度',
            display: 'inline',
            setter: 'NumberSetter',
            defaultValue: 200,
          },
        ],
      }),
    },
    {
      title: '高级配置',
      type: 'group',
      collapsed: true,
      display: 'accordion',
      items: [
        {
          name: 'handleProps',
          title: '手动设置组件props',
          display: 'inline',
          setter: getJSExpressionPrototype({
            type: 'props',
          }),
        },
      ],
    },
  ],
});

export default CnSliderBundle;
